import CardTable from 'models/CardTable'
import Practice from 'models/Practice'
import Answer from 'models/Answer'

export default {
  cardTableStore: new CardTable(),
  practiceStore: new Practice(),
  answerStore: new Answer()
}



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/